var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('carousel'),_c('periodicals'),_c('directions'),_c('programs'),_c('newsEvents')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }